import React from 'react';
import AgentCard from '../atoms/AgentCard'; 
import { Crew } from '../types/Crew.types';
import Spinner from '../atoms/Spinner';

interface Agent {
    id: string;
    name: string;
    updatedOn: string;
    createdBy: string;
    usedLLM: string;
}

interface AgentListProps {
  agents: Agent[];
  crewName?: string;
  crewId: string;
  loading?: boolean;
  onDelete: (id: number) => void; 
}

const AgentList: React.FC<AgentListProps> = ({ 
  agents, 
  crewName, 
  loading = false, 
  crewId, 
  onDelete 
}) => {
  if (loading) {
    return <Spinner/>;
  }

  if (agents.length === 0) {
    return (
      <div className="text-center">
        <p>No agents are available.</p>
      </div>
    );
  }

  return (
    <div>
      {agents.map((agent) => (
        <div key={agent.id}>
          <AgentCard 
            agent={agent} 
            crewName={crewName} 
            crewId={crewId} 
            onDelete={onDelete}
           

          />
        </div>
      ))}
    </div>
  );
};

export default AgentList;